import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function fetchRejected(numberText) {
  const axios = axiosInstance().primoLab;
  let prescriptionRejected = [];

  await axios
    .get(`/prescription-rejections/${numberText}`)
    .then(async (response) => {
      prescriptionRejected = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { prescriptionRejected };
}
